import { createFileRoute } from '@tanstack/react-router';
import { CreativeReviewScreen } from '@/screens/creative-review';

export const Route = createFileRoute('/creative-review')({
  // Route-data exemption: the token lives in the URL FRAGMENT, which never reaches the router —
  // deliberately, so the credential stays out of server logs, Referer headers and Pages
  // requests. A loader cannot see it, which is the point.
  component: CreativeReviewScreen,
});
